import {
  ComplianceEntity,
  VerificationLaneStatus
} from "@wingspanhq/wingspan-api-sdk";
import { selectorComplianceEntityTaxLaneStatus } from "../../../selectors/selectorComplianceEntityTaxLaneStatus";

/** A payer-owned compliance entity already holds the contractor's tax identity. */
export const isTaxInfoAdded = (complianceEntity?: ComplianceEntity) =>
  !!complianceEntity;

/** The contractor's TIN failed the IRS match on the payer-owned entity. */
export const isVerificationFailed = (complianceEntity?: ComplianceEntity) =>
  selectorComplianceEntityTaxLaneStatus(complianceEntity) ===
  VerificationLaneStatus.FAILED;
